export const AUTH_URL = process.env.REACT_APP_AUTH_URL!;
export const BASE_URL = process.env.REACT_APP_BASE_URL!;
export const ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL!;
export const PAYMENT_BASE_URL = process.env.REACT_APP_PAYMENT_URL!;

export const MONO_PUBLIC_KEY = process.env.REACT_APP_MONO_PUBLIC_KEY!;
export const MONO_SECRET_KEY = process.env.REACT_APP_MONO_SECRET_KEY!;

